const shortcuts = [];
export function registerShortcut(shortcut) {
    shortcuts.push(shortcut);
    return () => {
        const index = shortcuts.indexOf(shortcut);
        if (index >= 0)
            shortcuts.splice(index, 1);
    };
}
export function getRegisteredShortcuts() {
    return [...shortcuts];
}
/** Clears registered shortcuts and chord buffer — test environments only. */
export function resetKeyboardShortcutsForTests() {
    shortcuts.length = 0;
    sequenceBuffer = '';
    if (sequenceTimeout)
        clearTimeout(sequenceTimeout);
    sequenceTimeout = null;
}
let sequenceBuffer = '';
let sequenceTimeout = null;
export function handleKeyDown(event) {
    const target = event.target;
    const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
    for (const shortcut of shortcuts) {
        if (shortcut.meta && !event.metaKey && !event.ctrlKey)
            continue;
        if (shortcut.ctrl && !event.ctrlKey)
            continue;
        if (shortcut.shift && !event.shiftKey)
            continue;
        if (shortcut.key.length === 1 && shortcut.key === event.key && !shortcut.meta && !shortcut.ctrl) {
            if (isInput)
                return;
            event.preventDefault();
            shortcut.handler();
            return;
        }
        if (shortcut.meta && shortcut.key === event.key.toLowerCase()) {
            event.preventDefault();
            shortcut.handler();
            return;
        }
    }
    if (!isInput && !event.metaKey && !event.ctrlKey && event.key.length === 1) {
        if (sequenceTimeout)
            clearTimeout(sequenceTimeout);
        sequenceBuffer += event.key;
        sequenceTimeout = setTimeout(() => { sequenceBuffer = ''; }, 500);
        for (const shortcut of shortcuts) {
            if (shortcut.key === sequenceBuffer && !shortcut.meta && !shortcut.ctrl) {
                event.preventDefault();
                sequenceBuffer = '';
                if (sequenceTimeout)
                    clearTimeout(sequenceTimeout);
                shortcut.handler();
                return;
            }
        }
    }
}
